// Top nav for the Editorial Warm pages.
//
// "Book a visit" dispatches the `nala-open-booking` window event so any
// EditorialLayout instance below can pop the modal — the header itself
// owns no booking state. "Locations" links to the /locations stub and
// "Login" routes to the existing portal sign-in.

import { Link, NavLink } from 'react-router-dom'
import { nala } from './palette'

// In-page anchors are always written as absolute hash hrefs so they
// route to the home page and scroll, regardless of which page the
// visitor is currently on.
const NAV_LINKS = [
  { href: '/#how',                 label: 'How it works' },
  { href: '/#services',            label: 'Services' },
  { to:   '/locations',            label: 'Locations' },
  { href: '/#faq',                 label: 'FAQ' },
] as const

export default function EditorialHeader() {
  return (
    <header
      className="sticky top-0 z-40"
      style={{
        background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(8px)',
        borderBottom: `1px solid ${nala.line}`,
      }}
    >
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10 lg:px-14 py-4 flex items-center justify-between gap-6">
        {/* Wordmark */}
        <Link to="/" className="flex items-baseline gap-2.5 shrink-0 no-underline">
          <span
            className="text-[22px] font-semibold tracking-tight"
            style={{ fontFamily: nala.display, color: nala.ink }}
          >
            Nala
          </span>
          <span
            className="hidden md:inline italic text-[13px]"
            style={{ fontFamily: nala.display, color: nala.mute }}
          >
            built for pets, inspired by pet parents
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((link) =>
            'to' in link ? (
              <NavLink
                key={link.label}
                to={link.to}
                className="text-sm font-medium transition-colors"
                style={({ isActive }) => ({
                  color: isActive ? nala.clay : nala.ink,
                  textDecoration: 'none',
                })}
              >
                {link.label}
              </NavLink>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-medium transition-colors hover:opacity-80"
                style={{ color: nala.ink, textDecoration: 'none' }}
              >
                {link.label}
              </a>
            ),
          )}
          <Link
            to="/portal/sign-in"
            className="text-sm font-medium"
            style={{ color: nala.clay, textDecoration: 'none' }}
          >
            Login
          </Link>
        </nav>

        {/* Always-visible CTA */}
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent('nala-open-booking'))}
          className="rounded-full font-semibold text-[13px] transition-transform hover:-translate-y-px shrink-0"
          style={{
            background: nala.accent,
            color: nala.accentInk,
            padding: '10px 18px',
            fontFamily: nala.sans,
          }}
        >
          Book a visit
        </button>
      </div>
    </header>
  )
}
